import { render, staticRenderFns } from "./NumberCell.vue?vue&type=template&id=1311a2fc&scoped=true&"
import script from "./NumberCell.vue?vue&type=script&lang=js&"
export * from "./NumberCell.vue?vue&type=script&lang=js&"
import style0 from "./NumberCell.vue?vue&type=style&index=0&id=1311a2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311a2fc",
  null
  
)

export default component.exports